import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var content = 'fx_c76f37be_doefz80';
var contentCommandRoot = 'fx_c76f37be_doefz8a';
var contentScrollAreaViewport = 'fx_c76f37be_doefz89';
var contentVariants = createRuntimeFn({defaultClassName:'fx_c76f37be_doefz83',variantClassNames:{fitToTrigger:{true:'fx_c76f37be_doefz84',false:'fx_c76f37be_doefz85'},prefersReducedMotion:{reduce:'fx_c76f37be_doefz86',noPreference:'fx_c76f37be_doefz87'}},defaultVariants:{fitToTrigger:false,prefersReducedMotion:'noPreference'},compoundVariants:[]});

export { content, contentCommandRoot, contentScrollAreaViewport, contentVariants };
//# sourceMappingURL=content.vanilla.mjs.map
